import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import clsx from "clsx";

import { actionGetSignals } from "../../../redux/action/tunder/actionSignals";
import { AppDispatch } from "../../../redux/reducer/store";

import LimitSelect from "../../custom/limitSelect/limitSelect";
import Pagination from "../../pagination/pagination";
import Loader from "../../custom/loader/loader";
import Select from "../../../components/custom/select/select";

import "../../../scss/App.scss";
import "../table.scss";
import { IUserOptions } from "../../../types/interfaces";
import {
  IAddAccessInputValue,
  IEditAccessInputValue,
  initialAddInputState,
  initialEditInputState,
} from "../../../types/tunderinterfaces";
import {
  actionAddAccess,
  actionEditAccess,
  actionGetAccess,
} from "../../../redux/action/tunder/actionAccess";
import { actionGetServiceTypesSelect } from "../../../redux/action/easymerch/actionServiceTypes";

import Checkbox from "../../../assets/images/checkbox.png";
import Delete from "../../../assets/images/delete.png";
import Edit from "../../../assets/images/edit.png";
import { actionGetSimplifiedProjectsList } from "../../../redux/action/projects/actionProjects";
import ToastPopup from "../../custom/toastPopup/toastPopup";
import toast, { Toaster } from "react-hot-toast";
import { generateStyles } from "../../../utils/generateToastStyles";
import { reducerSetAccessRequestStatus } from "../../../redux/reducer/tunder/reducers/reducerAccess";
import { isValidEmail } from "../../../utils/formsValidation";

const requestStatusOptions = [
  {
    status: 200,
    successMessage: "Операция успешно выполнена!",
  },
  {
    status: 0,
    errorMessage: "При добавлении произошла ошибка!",
  },
  {
    status: 400,
    errorMessage: "",
  },
  {
    status: "updateSuccess",
    successMessage: "Данные успешно обновлены!",
  },
  {
    status: "updateError",
    errorMessage: "При обновлении данных произошла ошибка!",
  },
  {
    status: "invalidEmail",
    errorMessage: "Некорректный адрес электронной почты!",
  },
  {
    status: "emptyFields",
    errorMessage: "Все поля должны быть заполнены!",
  },
];

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const TableAccess: FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { access, offset, limit, requestStatus } = useSelector(
    (state: any) => state.tunder.access
  );
  const { selectContactById, selectContactOptions } = useSelector(
    (state: any) => state.easymerch.serviceTypes
  );

  const { isOpenSidebar } = useSelector(
    (state: IUserOptions) => state.user.user
  );

  const [isPending, setIsPending] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [startPage, setStartPage] = useState<number>(1);
  const [editRowId, setEditRowId] = useState<number | null>(null);
  const [editAccessInputValues, setEditAccessInputValues] =
    useState<IEditAccessInputValue>(initialEditInputState);
  const [addAccessInputValues, setAddAccessInputValues] =
    useState<IAddAccessInputValue>(initialAddInputState);

  const actualLimit =
    JSON.parse(localStorage.getItem("pageLimit") as string) || limit;

  useEffect(() => {
    dispatch(actionGetAccess(actualLimit, offset));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(actionGetServiceTypesSelect());
    dispatch(actionGetSimplifiedProjectsList(1000, 1)).then(() => {
      setIsPending(false);
    });
  }, [dispatch]);

  useEffect(() => {
    requestStatusOptions.forEach(
      (option: {
        status: number | string;
        successMessage?: string;
        errorMessage?: string | undefined;
      }) => {
        if (requestStatus === option.status) {
          toast.dismiss();
          toast(
            (t) => (
              <ToastPopup
                title={
                  option.successMessage
                    ? option.successMessage
                    : option.errorMessage
                }
                isSuccess={option.successMessage ? true : false}
                toast={toast}
                t={t}
              />
            ),
            generateStyles(option.successMessage ? true : false)
          );
        }
      }
    );

    setTimeout(() => {
      dispatch(reducerSetAccessRequestStatus(null));
    }, 5000);
  }, [dispatch, requestStatus]);

  const handleChange = (newLimit: number, newOffset: number) => {
    setIsPending(true);
    dispatch(actionGetSignals(newLimit, newOffset)).then(() => {
      setIsPending(false);
    });
    localStorage.setItem("pageLimit", JSON.stringify(newLimit));
  };

  const handleChangeLimits = (option: { value: number }) => {
    handleChange(option.value, 0);
    setCurrentPage(1);
    setStartPage(1);
  };

  const handleCancelButton = () => {
    setEditRowId(null);
  };

  const handleSaveButton = () => {
    dispatch(actionEditAccess(editAccessInputValues));
    setEditRowId(null);
  };

  const handleEditRowButton = (item: any) => {
    setEditRowId(item.id);
    setEditAccessInputValues({
      id: item.id,
      login: item.login,
      contract: {
        value: item.contract.id,
        label: selectContactById[item.contract.id],
      },
      clientId: item.clientId,
      clientSecret: item.clientSecret,
    });
  };

  const handleAddButton = () => {
    if (
      !addAccessInputValues.login.trim() ||
      !addAccessInputValues.clientId.trim() ||
      !addAccessInputValues.clientSecret.trim() ||
      !addAccessInputValues.email.trim() ||
      !addAccessInputValues.contract
    ) {
      dispatch(reducerSetAccessRequestStatus("emptyFields"));
      return;
    }

    if (!isValidEmail(addAccessInputValues.email)) {
      dispatch(reducerSetAccessRequestStatus("invalidEmail"));
      return;
    }

    dispatch(actionAddAccess(addAccessInputValues)).then(() => {
      setAddAccessInputValues(initialAddInputState);
    });
  };
  return (
    <>
      <div className="loader__wrapper">
        {(!access || isPending) && <Loader />}
      </div>
      <div
        className={clsx(
          JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
            isOpenSidebar &&
            "active__table",
          !isOpenSidebar && "closed__table",
          "table"
        )}
      >
        {requestStatus && (
          <Toaster
            position="top-center"
            toastOptions={{
              duration: 5000,
            }}
          />
        )}
        <div className="table__wrapper">
          <table className="flexible-table flexible-table--max-width">
            <thead className="tunder__thead">
              <tr>
                <th className="signals__date_cell">
                  <span className="filter__title">Логин</span>
                </th>
                <th>
                  <span className="filter__title">Client Secret</span>
                </th>
                <th>
                  <span className="filter__title">Контракты</span>
                </th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {access &&
                access.map((item: any) => {
                  return (
                    <tr key={item.id}>
                      <td>
                        {editRowId === item.id && (
                          <div className="filter__block">
                            <input
                              name="addLogin"
                              onChange={(event) => {
                                setEditAccessInputValues({
                                  ...editAccessInputValues,
                                  login: event.target.value,
                                });
                              }}
                              type="text"
                              value={editAccessInputValues.login}
                            />
                          </div>
                        )}

                        {editRowId !== item.id && item.login}
                      </td>
                      <td>
                        {editRowId === item.id && (
                          <div className="filter__block">
                            <input
                              name="addClientSecret"
                              onChange={(event) => {
                                setEditAccessInputValues({
                                  ...editAccessInputValues,
                                  clientSecret: event.target.value,
                                });
                              }}
                              type="text"
                              value={editAccessInputValues.clientSecret}
                            />
                          </div>
                        )}

                        {editRowId !== item.id && item.clientSecret}
                      </td>
                      <td>
                        {editRowId === item.id && (
                          <Select
                            options={selectContactOptions}
                            propsChange={(event: {
                              value: number;
                              label: string;
                            }) => {
                              setEditAccessInputValues({
                                ...editAccessInputValues,
                                contract: {
                                  value: event.value,
                                  label: event.label,
                                },
                              });
                            }}
                            value={editAccessInputValues.contract}
                            placeholder="Проект"
                            name="desktop"
                            isShowPlaceholder={true}
                            className=""
                          />
                        )}

                        {editRowId !== item.id &&
                          selectContactById &&
                          selectContactById[item.contract.id]}
                      </td>
                      <td className="flexible-table_edit-td">
                        {editRowId === item.id && (
                          <div
                            className="buttons__action"
                            onClick={handleSaveButton}
                          >
                            <img
                              className="customers__icon"
                              src={Checkbox}
                              alt="Сохранить"
                            />
                            <span className="buttons__action__green">
                              Сохранить
                            </span>
                          </div>
                        )}

                        {editRowId !== item.id && (
                          <div
                            className="buttons__action"
                            onClick={() => handleEditRowButton(item)}
                          >
                            <img
                              className="customers__icon"
                              src={Edit}
                              alt="Редактировать"
                            />
                            <span className="buttons__action__green">
                              Редактировать
                            </span>
                          </div>
                        )}
                      </td>
                      <td className="flexible-table_edit-td">
                        {editRowId === item.id && (
                          <div
                            className="buttons__action"
                            onClick={handleCancelButton}
                          >
                            <img
                              className="customers__icon"
                              src={Delete}
                              alt="Отменить"
                            />
                            <span>Отменить</span>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          <div className="add_form__container">
            <div className="add_form">
              <h3>Добавить доступ</h3>
              <div className="add_form__row">
                <div className="filter__block filter__block--max-height">
                  <input
                    name="addAccessLogin"
                    onChange={(event) => {
                      setAddAccessInputValues({
                        ...addAccessInputValues,
                        login: event.target.value,
                      });
                    }}
                    placeholder=""
                    type="text"
                    value={addAccessInputValues.login}
                  />
                  <label>Логин</label>
                </div>
                <div className="filter__block filter__block--max-height">
                  <input
                    name="addAccessPassword"
                    onChange={(event) => {
                      setAddAccessInputValues({
                        ...addAccessInputValues,
                        clientSecret: event.target.value,
                      });
                    }}
                    placeholder=""
                    type="text"
                    value={addAccessInputValues.clientSecret}
                  />
                  <label>ClientSecret</label>
                </div>
              </div>
              <div className="add_form__row">
                <div className="filter__block filter__block--max-height">
                  <input
                    name="addAccessClientId"
                    onChange={(event) => {
                      setAddAccessInputValues({
                        ...addAccessInputValues,
                        clientId: event.target.value,
                      });
                    }}
                    placeholder=""
                    type="text"
                    value={addAccessInputValues.clientId}
                  />
                  <label>Client Id</label>
                </div>
                <div className="filter__block filter__block--max-height">
                  <input
                    name="addAccessEmail"
                    onChange={(event) => {
                      setAddAccessInputValues({
                        ...addAccessInputValues,
                        email: event.target.value,
                      });
                    }}
                    placeholder=""
                    type="text"
                    value={addAccessInputValues.email}
                  />
                  <label>Email</label>
                </div>
              </div>
              <div className="multiselect__filter_block multiselect__filter_block--nomax">
                <Select
                  options={selectContactOptions}
                  propsChange={(event: { value: number; label: string }) => {
                    setAddAccessInputValues({
                      ...addAccessInputValues,
                      contract: {
                        value: event.value,
                        label: event.label,
                      },
                    });
                  }}
                  value={addAccessInputValues.contract}
                  placeholder="Контракт"
                  className="users__filter"
                  name="desktop"
                  isShowPlaceholder={true}
                />
              </div>
              <div className="add_form__row add_form__row--button">
                <div className="filter__block filter__block--button">
                  <button onClick={handleAddButton} className="table-button">
                    Добавить
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div className="pagination">
          <div className="pagination__count">Всего: {access?.length || 0}</div>
          <div className="pagination__str">
            <span>Отображать строки</span>
            <LimitSelect limit={actualLimit} propsChange={handleChangeLimits} />
          </div>
          <Pagination
            setCurrentPage={setCurrentPage}
            setStartPage={setStartPage}
            handleChange={handleChange}
            currentPage={currentPage}
            startPage={startPage}
            count={access?.length || 0}
            limit={actualLimit}
          />
        </div>
      </div>
    </>
  );
};

export default TableAccess;
